/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InsertGroupFromLibraryRequestDto } from '../models';
// @ts-ignore
import type { InsertSubgroupFromLibraryRequestDto } from '../models';
// @ts-ignore
import type { PredefinedOfferCreationRequestDto } from '../models';
// @ts-ignore
import type { ProcessOfferCopyRequestDto } from '../models';
// @ts-ignore
import type { ProcessOfferCreationRequestDto } from '../models';
// @ts-ignore
import type { ProcessOfferDto } from '../models';
// @ts-ignore
import type { ProcessOfferGroupCreationRequestDto } from '../models';
// @ts-ignore
import type { ProcessOfferGroupDetailsDto } from '../models';
// @ts-ignore
import type { ProcessOfferGroupIdDto } from '../models';
// @ts-ignore
import type { ProcessOfferGroupSelectionRequestDto } from '../models';
// @ts-ignore
import type { ProcessOfferGroupUpdateRequestDto } from '../models';
// @ts-ignore
import type { ProcessOfferIdDto } from '../models';
// @ts-ignore
import type { ProcessOfferScheduleUpdateRequestDto } from '../models';
// @ts-ignore
import type { ProcessOfferSearchRequestDto } from '../models';
// @ts-ignore
import type { ProcessOfferSearchResponseDto } from '../models';
// @ts-ignore
import type { ProcessOfferStatusDto } from '../models';
// @ts-ignore
import type { ProcessOfferStructureOrderRequestDto } from '../models';
// @ts-ignore
import type { ProcessOfferSubgroupCreationRequestDto } from '../models';
// @ts-ignore
import type { ProcessOfferSubgroupDishItemDto } from '../models';
// @ts-ignore
import type { ProcessOfferSubgroupDto } from '../models';
// @ts-ignore
import type { ProcessOfferSubgroupIdDto } from '../models';
// @ts-ignore
import type { ProcessOfferSubgroupSelectionRequestDto } from '../models';
// @ts-ignore
import type { ProcessOfferSubgroupUpdateRequestDto } from '../models';
// @ts-ignore
import type { ProcessOfferUpdateRequestDto } from '../models';
// @ts-ignore
import type { ProcessOfferUpdateStatusRequestDto } from '../models';
// @ts-ignore
import type { UpdateProcessOfferCommentRequestDto } from '../models';
// @ts-ignore
import type { UpdateProcessOfferSubgroupDishRequestDto } from '../models';
// @ts-ignore
import type { UpdateProcessOfferSubgroupDishesRequestDto } from '../models';
/**
 * RestProcessOffersApi - axios parameter creator
 */
export const RestProcessOffersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Deep-copy an existing offer into a target process and multi-offer group
         * @param {string} userId 
         * @param {ProcessOfferCopyRequestDto} processOfferCopyRequestDto Deep copy an offer into another process+multi-offer with new metadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyProcessOffer: async (userId: string, processOfferCopyRequestDto: ProcessOfferCopyRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('copyProcessOffer', 'userId', userId)
            // verify required parameter 'processOfferCopyRequestDto' is not null or undefined
            assertParamExists('copyProcessOffer', 'processOfferCopyRequestDto', processOfferCopyRequestDto)
            const localVarPath = `/api/offers/copy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processOfferCopyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a predefined-offer template attached to the synthetic system process and multi-offer group dedicated to predefined offers. Returns the full offer so the client can route straight to the standard offer view. 
         * @summary Create a predefined-offer template (hosted under the system process)
         * @param {string} userId 
         * @param {PredefinedOfferCreationRequestDto} predefinedOfferCreationRequestDto Predefined-offer (template) creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPredefinedOffer: async (userId: string, predefinedOfferCreationRequestDto: PredefinedOfferCreationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createPredefinedOffer', 'userId', userId)
            // verify required parameter 'predefinedOfferCreationRequestDto' is not null or undefined
            assertParamExists('createPredefinedOffer', 'predefinedOfferCreationRequestDto', predefinedOfferCreationRequestDto)
            const localVarPath = `/api/predefined-offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(predefinedOfferCreationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create process offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {ProcessOfferCreationRequestDto} processOfferCreationRequestDto Process offer creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcessOffer: async (userId: string, processId: string, multiProcessOfferGroupId: string, processOfferCreationRequestDto: ProcessOfferCreationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createProcessOffer', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('createProcessOffer', 'processId', processId)
            // verify required parameter 'multiProcessOfferGroupId' is not null or undefined
            assertParamExists('createProcessOffer', 'multiProcessOfferGroupId', multiProcessOfferGroupId)
            // verify required parameter 'processOfferCreationRequestDto' is not null or undefined
            assertParamExists('createProcessOffer', 'processOfferCreationRequestDto', processOfferCreationRequestDto)
            const localVarPath = `/api/processes/{processId}/offers`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (multiProcessOfferGroupId !== undefined) {
                localVarQueryParameter['multiProcessOfferGroupId'] = multiProcessOfferGroupId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processOfferCreationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create process offer group
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {ProcessOfferGroupCreationRequestDto} processOfferGroupCreationRequestDto Process offer group creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcessOfferGroup: async (userId: string, processId: string, processOfferId: string, processOfferGroupCreationRequestDto: ProcessOfferGroupCreationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createProcessOfferGroup', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('createProcessOfferGroup', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('createProcessOfferGroup', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferGroupCreationRequestDto' is not null or undefined
            assertParamExists('createProcessOfferGroup', 'processOfferGroupCreationRequestDto', processOfferGroupCreationRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/groups`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processOfferGroupCreationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create process offer subgroup
         * @param {string} userId 
         * @param {string} processId 
         * @param {number} processOfferGroupId 
         * @param {ProcessOfferSubgroupCreationRequestDto} processOfferSubgroupCreationRequestDto Process offer subgroup creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcessOfferSubgroup: async (userId: string, processId: string, processOfferGroupId: number, processOfferSubgroupCreationRequestDto: ProcessOfferSubgroupCreationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('createProcessOfferSubgroup', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('createProcessOfferSubgroup', 'processId', processId)
            // verify required parameter 'processOfferGroupId' is not null or undefined
            assertParamExists('createProcessOfferSubgroup', 'processOfferGroupId', processOfferGroupId)
            // verify required parameter 'processOfferSubgroupCreationRequestDto' is not null or undefined
            assertParamExists('createProcessOfferSubgroup', 'processOfferSubgroupCreationRequestDto', processOfferSubgroupCreationRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/groups/{processOfferGroupId}/subgroups`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferGroupId}', encodeURIComponent(String(processOfferGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processOfferSubgroupCreationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete process offer group
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProcessOfferGroup: async (userId: string, processId: string, processOfferId: string, processOfferGroupId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteProcessOfferGroup', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('deleteProcessOfferGroup', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('deleteProcessOfferGroup', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferGroupId' is not null or undefined
            assertParamExists('deleteProcessOfferGroup', 'processOfferGroupId', processOfferGroupId)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/groups/{processOfferGroupId}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{processOfferGroupId}', encodeURIComponent(String(processOfferGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete process offer subgroup
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProcessOfferSubgroup: async (userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteProcessOfferSubgroup', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('deleteProcessOfferSubgroup', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('deleteProcessOfferSubgroup', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferGroupId' is not null or undefined
            assertParamExists('deleteProcessOfferSubgroup', 'processOfferGroupId', processOfferGroupId)
            // verify required parameter 'processOfferSubgroupId' is not null or undefined
            assertParamExists('deleteProcessOfferSubgroup', 'processOfferSubgroupId', processOfferSubgroupId)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/groups/{processOfferGroupId}/subgroups/{processOfferSubgroupId}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{processOfferGroupId}', encodeURIComponent(String(processOfferGroupId)))
                .replace('{processOfferSubgroupId}', encodeURIComponent(String(processOfferSubgroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Splits the subgroup\'s budget (guests × per-guest portions or grams) across its dishes in a single transaction, most expensive first and never below a dish\'s order minimum. A plain station keeps the dishes the budget covers and deselects the rest; a pick pool or a subgroup of a set inserted from a definition splits only among the selected dishes and never changes the selection. No-op for subgroups without a per-guest budget.
         * @summary Distribute the guest portion budget across a subgroup\'s dishes
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        distributeProcessOfferSubgroupPortions: async (userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('distributeProcessOfferSubgroupPortions', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('distributeProcessOfferSubgroupPortions', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('distributeProcessOfferSubgroupPortions', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferGroupId' is not null or undefined
            assertParamExists('distributeProcessOfferSubgroupPortions', 'processOfferGroupId', processOfferGroupId)
            // verify required parameter 'processOfferSubgroupId' is not null or undefined
            assertParamExists('distributeProcessOfferSubgroupPortions', 'processOfferSubgroupId', processOfferSubgroupId)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/groups/{processOfferGroupId}/subgroups/{processOfferSubgroupId}/distribute-portions`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{processOfferGroupId}', encodeURIComponent(String(processOfferGroupId)))
                .replace('{processOfferSubgroupId}', encodeURIComponent(String(processOfferSubgroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get process offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessOffer: async (userId: string, processId: string, processOfferId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getProcessOffer', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessOffer', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('getProcessOffer', 'processOfferId', processOfferId)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get process offer group
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessOfferGroupDetails: async (userId: string, processId: string, processOfferId: string, processOfferGroupId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getProcessOfferGroupDetails', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessOfferGroupDetails', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('getProcessOfferGroupDetails', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferGroupId' is not null or undefined
            assertParamExists('getProcessOfferGroupDetails', 'processOfferGroupId', processOfferGroupId)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/groups/{processOfferGroupId}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{processOfferGroupId}', encodeURIComponent(String(processOfferGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get process offer status allowed transitions
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessOfferStatusAllowedTransitions: async (processId: string, processOfferId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessOfferStatusAllowedTransitions', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('getProcessOfferStatusAllowedTransitions', 'processOfferId', processOfferId)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/status-allowed-transitions`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get process offer subgroup
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessOfferSubgroup: async (userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getProcessOfferSubgroup', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessOfferSubgroup', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('getProcessOfferSubgroup', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferGroupId' is not null or undefined
            assertParamExists('getProcessOfferSubgroup', 'processOfferGroupId', processOfferGroupId)
            // verify required parameter 'processOfferSubgroupId' is not null or undefined
            assertParamExists('getProcessOfferSubgroup', 'processOfferSubgroupId', processOfferSubgroupId)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/groups/{processOfferGroupId}/subgroups/{processOfferSubgroupId}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{processOfferGroupId}', encodeURIComponent(String(processOfferGroupId)))
                .replace('{processOfferSubgroupId}', encodeURIComponent(String(processOfferSubgroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get process offer subgroup dishes
         * @param {string} userId 
         * @param {string} processId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessOfferSubgroupDishes: async (userId: string, processId: string, processOfferGroupId: number, processOfferSubgroupId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getProcessOfferSubgroupDishes', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessOfferSubgroupDishes', 'processId', processId)
            // verify required parameter 'processOfferGroupId' is not null or undefined
            assertParamExists('getProcessOfferSubgroupDishes', 'processOfferGroupId', processOfferGroupId)
            // verify required parameter 'processOfferSubgroupId' is not null or undefined
            assertParamExists('getProcessOfferSubgroupDishes', 'processOfferSubgroupId', processOfferSubgroupId)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/groups/{processOfferGroupId}/subgroups/{processOfferSubgroupId}/dishes`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferGroupId}', encodeURIComponent(String(processOfferGroupId)))
                .replace('{processOfferSubgroupId}', encodeURIComponent(String(processOfferSubgroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insert (deep-copy) a library group into this offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {InsertGroupFromLibraryRequestDto} insertGroupFromLibraryRequestDto The library group to deep-copy into this offer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertGroupFromLibrary: async (userId: string, processId: string, processOfferId: string, insertGroupFromLibraryRequestDto: InsertGroupFromLibraryRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('insertGroupFromLibrary', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('insertGroupFromLibrary', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('insertGroupFromLibrary', 'processOfferId', processOfferId)
            // verify required parameter 'insertGroupFromLibraryRequestDto' is not null or undefined
            assertParamExists('insertGroupFromLibrary', 'insertGroupFromLibraryRequestDto', insertGroupFromLibraryRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/groups/insert-from-library`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(insertGroupFromLibraryRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insert (deep-copy) a library subgroup into a group of this offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {InsertSubgroupFromLibraryRequestDto} insertSubgroupFromLibraryRequestDto The library subgroup to deep-copy into a group of this offer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertSubgroupFromLibrary: async (userId: string, processId: string, processOfferId: string, processOfferGroupId: number, insertSubgroupFromLibraryRequestDto: InsertSubgroupFromLibraryRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('insertSubgroupFromLibrary', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('insertSubgroupFromLibrary', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('insertSubgroupFromLibrary', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferGroupId' is not null or undefined
            assertParamExists('insertSubgroupFromLibrary', 'processOfferGroupId', processOfferGroupId)
            // verify required parameter 'insertSubgroupFromLibraryRequestDto' is not null or undefined
            assertParamExists('insertSubgroupFromLibrary', 'insertSubgroupFromLibraryRequestDto', insertSubgroupFromLibraryRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/groups/{processOfferGroupId}/subgroups/insert-from-library`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{processOfferGroupId}', encodeURIComponent(String(processOfferGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(insertSubgroupFromLibraryRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search for process offers across all processes (all filters optional)
         * @param {number} page 
         * @param {number} pageSize 
         * @param {ProcessOfferSearchRequestDto} processOfferSearchRequestDto Process offer search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProcessOffers: async (page: number, pageSize: number, processOfferSearchRequestDto: ProcessOfferSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchProcessOffers', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchProcessOffers', 'pageSize', pageSize)
            // verify required parameter 'processOfferSearchRequestDto' is not null or undefined
            assertParamExists('searchProcessOffers', 'processOfferSearchRequestDto', processOfferSearchRequestDto)
            const localVarPath = `/api/offers/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processOfferSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update process offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {ProcessOfferUpdateRequestDto} processOfferUpdateRequestDto Process offer update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOffer: async (userId: string, processId: string, processOfferId: string, processOfferUpdateRequestDto: ProcessOfferUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateProcessOffer', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessOffer', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('updateProcessOffer', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferUpdateRequestDto' is not null or undefined
            assertParamExists('updateProcessOffer', 'processOfferUpdateRequestDto', processOfferUpdateRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processOfferUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update process offer group
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {ProcessOfferGroupUpdateRequestDto} processOfferGroupUpdateRequestDto Process offer group update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferGroup: async (userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferGroupUpdateRequestDto: ProcessOfferGroupUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateProcessOfferGroup', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessOfferGroup', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('updateProcessOfferGroup', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferGroupId' is not null or undefined
            assertParamExists('updateProcessOfferGroup', 'processOfferGroupId', processOfferGroupId)
            // verify required parameter 'processOfferGroupUpdateRequestDto' is not null or undefined
            assertParamExists('updateProcessOfferGroup', 'processOfferGroupUpdateRequestDto', processOfferGroupUpdateRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/groups/{processOfferGroupId}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{processOfferGroupId}', encodeURIComponent(String(processOfferGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processOfferGroupUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the realization comment of a process offer group — allowed also on a sent offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {UpdateProcessOfferCommentRequestDto} updateProcessOfferCommentRequestDto Realization comment of a group or subgroup; it prints only on the realization order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferGroupComment: async (userId: string, processId: string, processOfferId: string, processOfferGroupId: number, updateProcessOfferCommentRequestDto: UpdateProcessOfferCommentRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateProcessOfferGroupComment', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessOfferGroupComment', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('updateProcessOfferGroupComment', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferGroupId' is not null or undefined
            assertParamExists('updateProcessOfferGroupComment', 'processOfferGroupId', processOfferGroupId)
            // verify required parameter 'updateProcessOfferCommentRequestDto' is not null or undefined
            assertParamExists('updateProcessOfferGroupComment', 'updateProcessOfferCommentRequestDto', updateProcessOfferCommentRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/groups/{processOfferGroupId}/comment`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{processOfferGroupId}', encodeURIComponent(String(processOfferGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProcessOfferCommentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Include or exclude an optional PACKAGE group
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {ProcessOfferGroupSelectionRequestDto} processOfferGroupSelectionRequestDto Include or exclude an optional PACKAGE group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferGroupSelection: async (userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferGroupSelectionRequestDto: ProcessOfferGroupSelectionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateProcessOfferGroupSelection', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessOfferGroupSelection', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('updateProcessOfferGroupSelection', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferGroupId' is not null or undefined
            assertParamExists('updateProcessOfferGroupSelection', 'processOfferGroupId', processOfferGroupId)
            // verify required parameter 'processOfferGroupSelectionRequestDto' is not null or undefined
            assertParamExists('updateProcessOfferGroupSelection', 'processOfferGroupSelectionRequestDto', processOfferGroupSelectionRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/groups/{processOfferGroupId}/group-selection`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{processOfferGroupId}', encodeURIComponent(String(processOfferGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processOfferGroupSelectionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update process offer schedule
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {ProcessOfferScheduleUpdateRequestDto} processOfferScheduleUpdateRequestDto Process offer schedule update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferSchedule: async (userId: string, processId: string, processOfferId: string, processOfferScheduleUpdateRequestDto: ProcessOfferScheduleUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateProcessOfferSchedule', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessOfferSchedule', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('updateProcessOfferSchedule', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferScheduleUpdateRequestDto' is not null or undefined
            assertParamExists('updateProcessOfferSchedule', 'processOfferScheduleUpdateRequestDto', processOfferScheduleUpdateRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/schedule`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processOfferScheduleUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update process offer status
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {ProcessOfferUpdateStatusRequestDto} processOfferUpdateStatusRequestDto Process offer update status request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferStatus: async (userId: string, processId: string, processOfferId: string, processOfferUpdateStatusRequestDto: ProcessOfferUpdateStatusRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateProcessOfferStatus', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessOfferStatus', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('updateProcessOfferStatus', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferUpdateStatusRequestDto' is not null or undefined
            assertParamExists('updateProcessOfferStatus', 'processOfferUpdateStatusRequestDto', processOfferUpdateStatusRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/status`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processOfferUpdateStatusRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reorder the offer\'s groups and their subgroups
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {ProcessOfferStructureOrderRequestDto} processOfferStructureOrderRequestDto New order for the offer\&#39;s groups and subgroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferStructureOrder: async (userId: string, processId: string, processOfferId: string, processOfferStructureOrderRequestDto: ProcessOfferStructureOrderRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateProcessOfferStructureOrder', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessOfferStructureOrder', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('updateProcessOfferStructureOrder', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferStructureOrderRequestDto' is not null or undefined
            assertParamExists('updateProcessOfferStructureOrder', 'processOfferStructureOrderRequestDto', processOfferStructureOrderRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/structure-order`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processOfferStructureOrderRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update process offer subgroup
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {ProcessOfferSubgroupUpdateRequestDto} processOfferSubgroupUpdateRequestDto Process offer subgroup update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferSubgroup: async (userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, processOfferSubgroupUpdateRequestDto: ProcessOfferSubgroupUpdateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroup', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroup', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroup', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferGroupId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroup', 'processOfferGroupId', processOfferGroupId)
            // verify required parameter 'processOfferSubgroupId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroup', 'processOfferSubgroupId', processOfferSubgroupId)
            // verify required parameter 'processOfferSubgroupUpdateRequestDto' is not null or undefined
            assertParamExists('updateProcessOfferSubgroup', 'processOfferSubgroupUpdateRequestDto', processOfferSubgroupUpdateRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/groups/{processOfferGroupId}/subgroups/{processOfferSubgroupId}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{processOfferGroupId}', encodeURIComponent(String(processOfferGroupId)))
                .replace('{processOfferSubgroupId}', encodeURIComponent(String(processOfferSubgroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processOfferSubgroupUpdateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the realization comment of a process offer subgroup — allowed also on a sent offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {UpdateProcessOfferCommentRequestDto} updateProcessOfferCommentRequestDto Realization comment of a group or subgroup; it prints only on the realization order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferSubgroupComment: async (userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, updateProcessOfferCommentRequestDto: UpdateProcessOfferCommentRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupComment', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupComment', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupComment', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferGroupId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupComment', 'processOfferGroupId', processOfferGroupId)
            // verify required parameter 'processOfferSubgroupId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupComment', 'processOfferSubgroupId', processOfferSubgroupId)
            // verify required parameter 'updateProcessOfferCommentRequestDto' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupComment', 'updateProcessOfferCommentRequestDto', updateProcessOfferCommentRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/groups/{processOfferGroupId}/subgroups/{processOfferSubgroupId}/comment`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{processOfferGroupId}', encodeURIComponent(String(processOfferGroupId)))
                .replace('{processOfferSubgroupId}', encodeURIComponent(String(processOfferSubgroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProcessOfferCommentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update process offer subgroup dish
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {number} processOfferSubgroupDishId 
         * @param {UpdateProcessOfferSubgroupDishRequestDto} updateProcessOfferSubgroupDishRequestDto Update process offer subgroup dish request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferSubgroupDish: async (userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, processOfferSubgroupDishId: number, updateProcessOfferSubgroupDishRequestDto: UpdateProcessOfferSubgroupDishRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupDish', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupDish', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupDish', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferGroupId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupDish', 'processOfferGroupId', processOfferGroupId)
            // verify required parameter 'processOfferSubgroupId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupDish', 'processOfferSubgroupId', processOfferSubgroupId)
            // verify required parameter 'processOfferSubgroupDishId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupDish', 'processOfferSubgroupDishId', processOfferSubgroupDishId)
            // verify required parameter 'updateProcessOfferSubgroupDishRequestDto' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupDish', 'updateProcessOfferSubgroupDishRequestDto', updateProcessOfferSubgroupDishRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/groups/{processOfferGroupId}/subgroups/{processOfferSubgroupId}/dishes/{processOfferSubgroupDishId}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{processOfferGroupId}', encodeURIComponent(String(processOfferGroupId)))
                .replace('{processOfferSubgroupId}', encodeURIComponent(String(processOfferSubgroupId)))
                .replace('{processOfferSubgroupDishId}', encodeURIComponent(String(processOfferSubgroupDishId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProcessOfferSubgroupDishRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update process offer subgroup
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {UpdateProcessOfferSubgroupDishesRequestDto} updateProcessOfferSubgroupDishesRequestDto Update process offer subgroup dishes request (add or remove)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferSubgroupDishes: async (userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, updateProcessOfferSubgroupDishesRequestDto: UpdateProcessOfferSubgroupDishesRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupDishes', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupDishes', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupDishes', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferGroupId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupDishes', 'processOfferGroupId', processOfferGroupId)
            // verify required parameter 'processOfferSubgroupId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupDishes', 'processOfferSubgroupId', processOfferSubgroupId)
            // verify required parameter 'updateProcessOfferSubgroupDishesRequestDto' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupDishes', 'updateProcessOfferSubgroupDishesRequestDto', updateProcessOfferSubgroupDishesRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/groups/{processOfferGroupId}/subgroups/{processOfferSubgroupId}/dishes`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{processOfferGroupId}', encodeURIComponent(String(processOfferGroupId)))
                .replace('{processOfferSubgroupId}', encodeURIComponent(String(processOfferSubgroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProcessOfferSubgroupDishesRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set selected dishes in a PACKAGE subgroup pool
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {ProcessOfferSubgroupSelectionRequestDto} processOfferSubgroupSelectionRequestDto Set which pool dishes are selected in a PACKAGE subgroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferSubgroupSelection: async (userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, processOfferSubgroupSelectionRequestDto: ProcessOfferSubgroupSelectionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupSelection', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupSelection', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupSelection', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferGroupId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupSelection', 'processOfferGroupId', processOfferGroupId)
            // verify required parameter 'processOfferSubgroupId' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupSelection', 'processOfferSubgroupId', processOfferSubgroupId)
            // verify required parameter 'processOfferSubgroupSelectionRequestDto' is not null or undefined
            assertParamExists('updateProcessOfferSubgroupSelection', 'processOfferSubgroupSelectionRequestDto', processOfferSubgroupSelectionRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/groups/{processOfferGroupId}/subgroups/{processOfferSubgroupId}/dish-selection`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{processOfferGroupId}', encodeURIComponent(String(processOfferGroupId)))
                .replace('{processOfferSubgroupId}', encodeURIComponent(String(processOfferSubgroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processOfferSubgroupSelectionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestProcessOffersApi - functional programming interface
 */
export const RestProcessOffersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestProcessOffersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Deep-copy an existing offer into a target process and multi-offer group
         * @param {string} userId 
         * @param {ProcessOfferCopyRequestDto} processOfferCopyRequestDto Deep copy an offer into another process+multi-offer with new metadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyProcessOffer(userId: string, processOfferCopyRequestDto: ProcessOfferCopyRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessOfferIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyProcessOffer(userId, processOfferCopyRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.copyProcessOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a predefined-offer template attached to the synthetic system process and multi-offer group dedicated to predefined offers. Returns the full offer so the client can route straight to the standard offer view. 
         * @summary Create a predefined-offer template (hosted under the system process)
         * @param {string} userId 
         * @param {PredefinedOfferCreationRequestDto} predefinedOfferCreationRequestDto Predefined-offer (template) creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPredefinedOffer(userId: string, predefinedOfferCreationRequestDto: PredefinedOfferCreationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessOfferDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPredefinedOffer(userId, predefinedOfferCreationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.createPredefinedOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create process offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {ProcessOfferCreationRequestDto} processOfferCreationRequestDto Process offer creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProcessOffer(userId: string, processId: string, multiProcessOfferGroupId: string, processOfferCreationRequestDto: ProcessOfferCreationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessOfferIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProcessOffer(userId, processId, multiProcessOfferGroupId, processOfferCreationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.createProcessOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create process offer group
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {ProcessOfferGroupCreationRequestDto} processOfferGroupCreationRequestDto Process offer group creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProcessOfferGroup(userId: string, processId: string, processOfferId: string, processOfferGroupCreationRequestDto: ProcessOfferGroupCreationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessOfferGroupIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProcessOfferGroup(userId, processId, processOfferId, processOfferGroupCreationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.createProcessOfferGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create process offer subgroup
         * @param {string} userId 
         * @param {string} processId 
         * @param {number} processOfferGroupId 
         * @param {ProcessOfferSubgroupCreationRequestDto} processOfferSubgroupCreationRequestDto Process offer subgroup creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProcessOfferSubgroup(userId: string, processId: string, processOfferGroupId: number, processOfferSubgroupCreationRequestDto: ProcessOfferSubgroupCreationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessOfferSubgroupIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProcessOfferSubgroup(userId, processId, processOfferGroupId, processOfferSubgroupCreationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.createProcessOfferSubgroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete process offer group
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProcessOfferGroup(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProcessOfferGroup(userId, processId, processOfferId, processOfferGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.deleteProcessOfferGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete process offer subgroup
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProcessOfferSubgroup(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProcessOfferSubgroup(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.deleteProcessOfferSubgroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Splits the subgroup\'s budget (guests × per-guest portions or grams) across its dishes in a single transaction, most expensive first and never below a dish\'s order minimum. A plain station keeps the dishes the budget covers and deselects the rest; a pick pool or a subgroup of a set inserted from a definition splits only among the selected dishes and never changes the selection. No-op for subgroups without a per-guest budget.
         * @summary Distribute the guest portion budget across a subgroup\'s dishes
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async distributeProcessOfferSubgroupPortions(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.distributeProcessOfferSubgroupPortions(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.distributeProcessOfferSubgroupPortions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get process offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessOffer(userId: string, processId: string, processOfferId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessOfferDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessOffer(userId, processId, processOfferId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.getProcessOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get process offer group
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessOfferGroupDetails(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessOfferGroupDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessOfferGroupDetails(userId, processId, processOfferId, processOfferGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.getProcessOfferGroupDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get process offer status allowed transitions
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessOfferStatusAllowedTransitions(processId: string, processOfferId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProcessOfferStatusDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessOfferStatusAllowedTransitions(processId, processOfferId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.getProcessOfferStatusAllowedTransitions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get process offer subgroup
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessOfferSubgroup(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessOfferSubgroupDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessOfferSubgroup(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.getProcessOfferSubgroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get process offer subgroup dishes
         * @param {string} userId 
         * @param {string} processId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessOfferSubgroupDishes(userId: string, processId: string, processOfferGroupId: number, processOfferSubgroupId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProcessOfferSubgroupDishItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessOfferSubgroupDishes(userId, processId, processOfferGroupId, processOfferSubgroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.getProcessOfferSubgroupDishes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Insert (deep-copy) a library group into this offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {InsertGroupFromLibraryRequestDto} insertGroupFromLibraryRequestDto The library group to deep-copy into this offer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertGroupFromLibrary(userId: string, processId: string, processOfferId: string, insertGroupFromLibraryRequestDto: InsertGroupFromLibraryRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertGroupFromLibrary(userId, processId, processOfferId, insertGroupFromLibraryRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.insertGroupFromLibrary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Insert (deep-copy) a library subgroup into a group of this offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {InsertSubgroupFromLibraryRequestDto} insertSubgroupFromLibraryRequestDto The library subgroup to deep-copy into a group of this offer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertSubgroupFromLibrary(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, insertSubgroupFromLibraryRequestDto: InsertSubgroupFromLibraryRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertSubgroupFromLibrary(userId, processId, processOfferId, processOfferGroupId, insertSubgroupFromLibraryRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.insertSubgroupFromLibrary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search for process offers across all processes (all filters optional)
         * @param {number} page 
         * @param {number} pageSize 
         * @param {ProcessOfferSearchRequestDto} processOfferSearchRequestDto Process offer search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProcessOffers(page: number, pageSize: number, processOfferSearchRequestDto: ProcessOfferSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessOfferSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProcessOffers(page, pageSize, processOfferSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.searchProcessOffers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update process offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {ProcessOfferUpdateRequestDto} processOfferUpdateRequestDto Process offer update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessOffer(userId: string, processId: string, processOfferId: string, processOfferUpdateRequestDto: ProcessOfferUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessOffer(userId, processId, processOfferId, processOfferUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.updateProcessOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update process offer group
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {ProcessOfferGroupUpdateRequestDto} processOfferGroupUpdateRequestDto Process offer group update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessOfferGroup(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferGroupUpdateRequestDto: ProcessOfferGroupUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessOfferGroup(userId, processId, processOfferId, processOfferGroupId, processOfferGroupUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.updateProcessOfferGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the realization comment of a process offer group — allowed also on a sent offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {UpdateProcessOfferCommentRequestDto} updateProcessOfferCommentRequestDto Realization comment of a group or subgroup; it prints only on the realization order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessOfferGroupComment(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, updateProcessOfferCommentRequestDto: UpdateProcessOfferCommentRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessOfferGroupComment(userId, processId, processOfferId, processOfferGroupId, updateProcessOfferCommentRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.updateProcessOfferGroupComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Include or exclude an optional PACKAGE group
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {ProcessOfferGroupSelectionRequestDto} processOfferGroupSelectionRequestDto Include or exclude an optional PACKAGE group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessOfferGroupSelection(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferGroupSelectionRequestDto: ProcessOfferGroupSelectionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessOfferGroupSelection(userId, processId, processOfferId, processOfferGroupId, processOfferGroupSelectionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.updateProcessOfferGroupSelection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update process offer schedule
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {ProcessOfferScheduleUpdateRequestDto} processOfferScheduleUpdateRequestDto Process offer schedule update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessOfferSchedule(userId: string, processId: string, processOfferId: string, processOfferScheduleUpdateRequestDto: ProcessOfferScheduleUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessOfferSchedule(userId, processId, processOfferId, processOfferScheduleUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.updateProcessOfferSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update process offer status
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {ProcessOfferUpdateStatusRequestDto} processOfferUpdateStatusRequestDto Process offer update status request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessOfferStatus(userId: string, processId: string, processOfferId: string, processOfferUpdateStatusRequestDto: ProcessOfferUpdateStatusRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessOfferStatus(userId, processId, processOfferId, processOfferUpdateStatusRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.updateProcessOfferStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reorder the offer\'s groups and their subgroups
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {ProcessOfferStructureOrderRequestDto} processOfferStructureOrderRequestDto New order for the offer\&#39;s groups and subgroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessOfferStructureOrder(userId: string, processId: string, processOfferId: string, processOfferStructureOrderRequestDto: ProcessOfferStructureOrderRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessOfferStructureOrder(userId, processId, processOfferId, processOfferStructureOrderRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.updateProcessOfferStructureOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update process offer subgroup
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {ProcessOfferSubgroupUpdateRequestDto} processOfferSubgroupUpdateRequestDto Process offer subgroup update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessOfferSubgroup(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, processOfferSubgroupUpdateRequestDto: ProcessOfferSubgroupUpdateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessOfferSubgroup(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, processOfferSubgroupUpdateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.updateProcessOfferSubgroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the realization comment of a process offer subgroup — allowed also on a sent offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {UpdateProcessOfferCommentRequestDto} updateProcessOfferCommentRequestDto Realization comment of a group or subgroup; it prints only on the realization order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessOfferSubgroupComment(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, updateProcessOfferCommentRequestDto: UpdateProcessOfferCommentRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessOfferSubgroupComment(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, updateProcessOfferCommentRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.updateProcessOfferSubgroupComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update process offer subgroup dish
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {number} processOfferSubgroupDishId 
         * @param {UpdateProcessOfferSubgroupDishRequestDto} updateProcessOfferSubgroupDishRequestDto Update process offer subgroup dish request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessOfferSubgroupDish(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, processOfferSubgroupDishId: number, updateProcessOfferSubgroupDishRequestDto: UpdateProcessOfferSubgroupDishRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessOfferSubgroupDish(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, processOfferSubgroupDishId, updateProcessOfferSubgroupDishRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.updateProcessOfferSubgroupDish']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update process offer subgroup
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {UpdateProcessOfferSubgroupDishesRequestDto} updateProcessOfferSubgroupDishesRequestDto Update process offer subgroup dishes request (add or remove)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessOfferSubgroupDishes(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, updateProcessOfferSubgroupDishesRequestDto: UpdateProcessOfferSubgroupDishesRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessOfferSubgroupDishes(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, updateProcessOfferSubgroupDishesRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.updateProcessOfferSubgroupDishes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set selected dishes in a PACKAGE subgroup pool
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {ProcessOfferSubgroupSelectionRequestDto} processOfferSubgroupSelectionRequestDto Set which pool dishes are selected in a PACKAGE subgroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessOfferSubgroupSelection(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, processOfferSubgroupSelectionRequestDto: ProcessOfferSubgroupSelectionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessOfferSubgroupSelection(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, processOfferSubgroupSelectionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOffersApi.updateProcessOfferSubgroupSelection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestProcessOffersApi - factory interface
 */
export const RestProcessOffersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestProcessOffersApiFp(configuration)
    return {
        /**
         * 
         * @summary Deep-copy an existing offer into a target process and multi-offer group
         * @param {string} userId 
         * @param {ProcessOfferCopyRequestDto} processOfferCopyRequestDto Deep copy an offer into another process+multi-offer with new metadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyProcessOffer(userId: string, processOfferCopyRequestDto: ProcessOfferCopyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferIdDto> {
            return localVarFp.copyProcessOffer(userId, processOfferCopyRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a predefined-offer template attached to the synthetic system process and multi-offer group dedicated to predefined offers. Returns the full offer so the client can route straight to the standard offer view. 
         * @summary Create a predefined-offer template (hosted under the system process)
         * @param {string} userId 
         * @param {PredefinedOfferCreationRequestDto} predefinedOfferCreationRequestDto Predefined-offer (template) creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPredefinedOffer(userId: string, predefinedOfferCreationRequestDto: PredefinedOfferCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferDto> {
            return localVarFp.createPredefinedOffer(userId, predefinedOfferCreationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create process offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} multiProcessOfferGroupId 
         * @param {ProcessOfferCreationRequestDto} processOfferCreationRequestDto Process offer creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcessOffer(userId: string, processId: string, multiProcessOfferGroupId: string, processOfferCreationRequestDto: ProcessOfferCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferIdDto> {
            return localVarFp.createProcessOffer(userId, processId, multiProcessOfferGroupId, processOfferCreationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create process offer group
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {ProcessOfferGroupCreationRequestDto} processOfferGroupCreationRequestDto Process offer group creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcessOfferGroup(userId: string, processId: string, processOfferId: string, processOfferGroupCreationRequestDto: ProcessOfferGroupCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferGroupIdDto> {
            return localVarFp.createProcessOfferGroup(userId, processId, processOfferId, processOfferGroupCreationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create process offer subgroup
         * @param {string} userId 
         * @param {string} processId 
         * @param {number} processOfferGroupId 
         * @param {ProcessOfferSubgroupCreationRequestDto} processOfferSubgroupCreationRequestDto Process offer subgroup creation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcessOfferSubgroup(userId: string, processId: string, processOfferGroupId: number, processOfferSubgroupCreationRequestDto: ProcessOfferSubgroupCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferSubgroupIdDto> {
            return localVarFp.createProcessOfferSubgroup(userId, processId, processOfferGroupId, processOfferSubgroupCreationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete process offer group
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProcessOfferGroup(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProcessOfferGroup(userId, processId, processOfferId, processOfferGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete process offer subgroup
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProcessOfferSubgroup(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProcessOfferSubgroup(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Splits the subgroup\'s budget (guests × per-guest portions or grams) across its dishes in a single transaction, most expensive first and never below a dish\'s order minimum. A plain station keeps the dishes the budget covers and deselects the rest; a pick pool or a subgroup of a set inserted from a definition splits only among the selected dishes and never changes the selection. No-op for subgroups without a per-guest budget.
         * @summary Distribute the guest portion budget across a subgroup\'s dishes
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        distributeProcessOfferSubgroupPortions(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.distributeProcessOfferSubgroupPortions(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get process offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessOffer(userId: string, processId: string, processOfferId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferDto> {
            return localVarFp.getProcessOffer(userId, processId, processOfferId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get process offer group
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessOfferGroupDetails(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferGroupDetailsDto> {
            return localVarFp.getProcessOfferGroupDetails(userId, processId, processOfferId, processOfferGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get process offer status allowed transitions
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessOfferStatusAllowedTransitions(processId: string, processOfferId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProcessOfferStatusDto>> {
            return localVarFp.getProcessOfferStatusAllowedTransitions(processId, processOfferId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get process offer subgroup
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessOfferSubgroup(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferSubgroupDto> {
            return localVarFp.getProcessOfferSubgroup(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get process offer subgroup dishes
         * @param {string} userId 
         * @param {string} processId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessOfferSubgroupDishes(userId: string, processId: string, processOfferGroupId: number, processOfferSubgroupId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProcessOfferSubgroupDishItemDto>> {
            return localVarFp.getProcessOfferSubgroupDishes(userId, processId, processOfferGroupId, processOfferSubgroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insert (deep-copy) a library group into this offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {InsertGroupFromLibraryRequestDto} insertGroupFromLibraryRequestDto The library group to deep-copy into this offer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertGroupFromLibrary(userId: string, processId: string, processOfferId: string, insertGroupFromLibraryRequestDto: InsertGroupFromLibraryRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.insertGroupFromLibrary(userId, processId, processOfferId, insertGroupFromLibraryRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insert (deep-copy) a library subgroup into a group of this offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {InsertSubgroupFromLibraryRequestDto} insertSubgroupFromLibraryRequestDto The library subgroup to deep-copy into a group of this offer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertSubgroupFromLibrary(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, insertSubgroupFromLibraryRequestDto: InsertSubgroupFromLibraryRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.insertSubgroupFromLibrary(userId, processId, processOfferId, processOfferGroupId, insertSubgroupFromLibraryRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search for process offers across all processes (all filters optional)
         * @param {number} page 
         * @param {number} pageSize 
         * @param {ProcessOfferSearchRequestDto} processOfferSearchRequestDto Process offer search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProcessOffers(page: number, pageSize: number, processOfferSearchRequestDto: ProcessOfferSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferSearchResponseDto> {
            return localVarFp.searchProcessOffers(page, pageSize, processOfferSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update process offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {ProcessOfferUpdateRequestDto} processOfferUpdateRequestDto Process offer update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOffer(userId: string, processId: string, processOfferId: string, processOfferUpdateRequestDto: ProcessOfferUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessOffer(userId, processId, processOfferId, processOfferUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update process offer group
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {ProcessOfferGroupUpdateRequestDto} processOfferGroupUpdateRequestDto Process offer group update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferGroup(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferGroupUpdateRequestDto: ProcessOfferGroupUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessOfferGroup(userId, processId, processOfferId, processOfferGroupId, processOfferGroupUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the realization comment of a process offer group — allowed also on a sent offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {UpdateProcessOfferCommentRequestDto} updateProcessOfferCommentRequestDto Realization comment of a group or subgroup; it prints only on the realization order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferGroupComment(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, updateProcessOfferCommentRequestDto: UpdateProcessOfferCommentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessOfferGroupComment(userId, processId, processOfferId, processOfferGroupId, updateProcessOfferCommentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Include or exclude an optional PACKAGE group
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {ProcessOfferGroupSelectionRequestDto} processOfferGroupSelectionRequestDto Include or exclude an optional PACKAGE group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferGroupSelection(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferGroupSelectionRequestDto: ProcessOfferGroupSelectionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessOfferGroupSelection(userId, processId, processOfferId, processOfferGroupId, processOfferGroupSelectionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update process offer schedule
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {ProcessOfferScheduleUpdateRequestDto} processOfferScheduleUpdateRequestDto Process offer schedule update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferSchedule(userId: string, processId: string, processOfferId: string, processOfferScheduleUpdateRequestDto: ProcessOfferScheduleUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessOfferSchedule(userId, processId, processOfferId, processOfferScheduleUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update process offer status
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {ProcessOfferUpdateStatusRequestDto} processOfferUpdateStatusRequestDto Process offer update status request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferStatus(userId: string, processId: string, processOfferId: string, processOfferUpdateStatusRequestDto: ProcessOfferUpdateStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessOfferStatus(userId, processId, processOfferId, processOfferUpdateStatusRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reorder the offer\'s groups and their subgroups
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {ProcessOfferStructureOrderRequestDto} processOfferStructureOrderRequestDto New order for the offer\&#39;s groups and subgroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferStructureOrder(userId: string, processId: string, processOfferId: string, processOfferStructureOrderRequestDto: ProcessOfferStructureOrderRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessOfferStructureOrder(userId, processId, processOfferId, processOfferStructureOrderRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update process offer subgroup
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {ProcessOfferSubgroupUpdateRequestDto} processOfferSubgroupUpdateRequestDto Process offer subgroup update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferSubgroup(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, processOfferSubgroupUpdateRequestDto: ProcessOfferSubgroupUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessOfferSubgroup(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, processOfferSubgroupUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the realization comment of a process offer subgroup — allowed also on a sent offer
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {UpdateProcessOfferCommentRequestDto} updateProcessOfferCommentRequestDto Realization comment of a group or subgroup; it prints only on the realization order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferSubgroupComment(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, updateProcessOfferCommentRequestDto: UpdateProcessOfferCommentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessOfferSubgroupComment(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, updateProcessOfferCommentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update process offer subgroup dish
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {number} processOfferSubgroupDishId 
         * @param {UpdateProcessOfferSubgroupDishRequestDto} updateProcessOfferSubgroupDishRequestDto Update process offer subgroup dish request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferSubgroupDish(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, processOfferSubgroupDishId: number, updateProcessOfferSubgroupDishRequestDto: UpdateProcessOfferSubgroupDishRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessOfferSubgroupDish(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, processOfferSubgroupDishId, updateProcessOfferSubgroupDishRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update process offer subgroup
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {UpdateProcessOfferSubgroupDishesRequestDto} updateProcessOfferSubgroupDishesRequestDto Update process offer subgroup dishes request (add or remove)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferSubgroupDishes(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, updateProcessOfferSubgroupDishesRequestDto: UpdateProcessOfferSubgroupDishesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessOfferSubgroupDishes(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, updateProcessOfferSubgroupDishesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set selected dishes in a PACKAGE subgroup pool
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferGroupId 
         * @param {number} processOfferSubgroupId 
         * @param {ProcessOfferSubgroupSelectionRequestDto} processOfferSubgroupSelectionRequestDto Set which pool dishes are selected in a PACKAGE subgroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferSubgroupSelection(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, processOfferSubgroupSelectionRequestDto: ProcessOfferSubgroupSelectionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessOfferSubgroupSelection(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, processOfferSubgroupSelectionRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestProcessOffersApi - interface
 */
export interface RestProcessOffersApiInterface {
    /**
     * 
     * @summary Deep-copy an existing offer into a target process and multi-offer group
     * @param {string} userId 
     * @param {ProcessOfferCopyRequestDto} processOfferCopyRequestDto Deep copy an offer into another process+multi-offer with new metadata
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    copyProcessOffer(userId: string, processOfferCopyRequestDto: ProcessOfferCopyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferIdDto>;

    /**
     * Creates a predefined-offer template attached to the synthetic system process and multi-offer group dedicated to predefined offers. Returns the full offer so the client can route straight to the standard offer view. 
     * @summary Create a predefined-offer template (hosted under the system process)
     * @param {string} userId 
     * @param {PredefinedOfferCreationRequestDto} predefinedOfferCreationRequestDto Predefined-offer (template) creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPredefinedOffer(userId: string, predefinedOfferCreationRequestDto: PredefinedOfferCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferDto>;

    /**
     * 
     * @summary Create process offer
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} multiProcessOfferGroupId 
     * @param {ProcessOfferCreationRequestDto} processOfferCreationRequestDto Process offer creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createProcessOffer(userId: string, processId: string, multiProcessOfferGroupId: string, processOfferCreationRequestDto: ProcessOfferCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferIdDto>;

    /**
     * 
     * @summary Create process offer group
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {ProcessOfferGroupCreationRequestDto} processOfferGroupCreationRequestDto Process offer group creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createProcessOfferGroup(userId: string, processId: string, processOfferId: string, processOfferGroupCreationRequestDto: ProcessOfferGroupCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferGroupIdDto>;

    /**
     * 
     * @summary Create process offer subgroup
     * @param {string} userId 
     * @param {string} processId 
     * @param {number} processOfferGroupId 
     * @param {ProcessOfferSubgroupCreationRequestDto} processOfferSubgroupCreationRequestDto Process offer subgroup creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createProcessOfferSubgroup(userId: string, processId: string, processOfferGroupId: number, processOfferSubgroupCreationRequestDto: ProcessOfferSubgroupCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferSubgroupIdDto>;

    /**
     * 
     * @summary Delete process offer group
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProcessOfferGroup(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete process offer subgroup
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {number} processOfferSubgroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProcessOfferSubgroup(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Splits the subgroup\'s budget (guests × per-guest portions or grams) across its dishes in a single transaction, most expensive first and never below a dish\'s order minimum. A plain station keeps the dishes the budget covers and deselects the rest; a pick pool or a subgroup of a set inserted from a definition splits only among the selected dishes and never changes the selection. No-op for subgroups without a per-guest budget.
     * @summary Distribute the guest portion budget across a subgroup\'s dishes
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {number} processOfferSubgroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    distributeProcessOfferSubgroupPortions(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get process offer
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessOffer(userId: string, processId: string, processOfferId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferDto>;

    /**
     * 
     * @summary Get process offer group
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessOfferGroupDetails(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferGroupDetailsDto>;

    /**
     * 
     * @summary Get process offer status allowed transitions
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessOfferStatusAllowedTransitions(processId: string, processOfferId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProcessOfferStatusDto>>;

    /**
     * 
     * @summary Get process offer subgroup
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {number} processOfferSubgroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessOfferSubgroup(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferSubgroupDto>;

    /**
     * 
     * @summary Get process offer subgroup dishes
     * @param {string} userId 
     * @param {string} processId 
     * @param {number} processOfferGroupId 
     * @param {number} processOfferSubgroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessOfferSubgroupDishes(userId: string, processId: string, processOfferGroupId: number, processOfferSubgroupId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProcessOfferSubgroupDishItemDto>>;

    /**
     * 
     * @summary Insert (deep-copy) a library group into this offer
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {InsertGroupFromLibraryRequestDto} insertGroupFromLibraryRequestDto The library group to deep-copy into this offer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    insertGroupFromLibrary(userId: string, processId: string, processOfferId: string, insertGroupFromLibraryRequestDto: InsertGroupFromLibraryRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Insert (deep-copy) a library subgroup into a group of this offer
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {InsertSubgroupFromLibraryRequestDto} insertSubgroupFromLibraryRequestDto The library subgroup to deep-copy into a group of this offer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    insertSubgroupFromLibrary(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, insertSubgroupFromLibraryRequestDto: InsertSubgroupFromLibraryRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Search for process offers across all processes (all filters optional)
     * @param {number} page 
     * @param {number} pageSize 
     * @param {ProcessOfferSearchRequestDto} processOfferSearchRequestDto Process offer search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchProcessOffers(page: number, pageSize: number, processOfferSearchRequestDto: ProcessOfferSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferSearchResponseDto>;

    /**
     * 
     * @summary Update process offer
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {ProcessOfferUpdateRequestDto} processOfferUpdateRequestDto Process offer update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessOffer(userId: string, processId: string, processOfferId: string, processOfferUpdateRequestDto: ProcessOfferUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update process offer group
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {ProcessOfferGroupUpdateRequestDto} processOfferGroupUpdateRequestDto Process offer group update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessOfferGroup(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferGroupUpdateRequestDto: ProcessOfferGroupUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update the realization comment of a process offer group — allowed also on a sent offer
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {UpdateProcessOfferCommentRequestDto} updateProcessOfferCommentRequestDto Realization comment of a group or subgroup; it prints only on the realization order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessOfferGroupComment(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, updateProcessOfferCommentRequestDto: UpdateProcessOfferCommentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Include or exclude an optional PACKAGE group
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {ProcessOfferGroupSelectionRequestDto} processOfferGroupSelectionRequestDto Include or exclude an optional PACKAGE group
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessOfferGroupSelection(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferGroupSelectionRequestDto: ProcessOfferGroupSelectionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update process offer schedule
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {ProcessOfferScheduleUpdateRequestDto} processOfferScheduleUpdateRequestDto Process offer schedule update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessOfferSchedule(userId: string, processId: string, processOfferId: string, processOfferScheduleUpdateRequestDto: ProcessOfferScheduleUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update process offer status
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {ProcessOfferUpdateStatusRequestDto} processOfferUpdateStatusRequestDto Process offer update status request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessOfferStatus(userId: string, processId: string, processOfferId: string, processOfferUpdateStatusRequestDto: ProcessOfferUpdateStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Reorder the offer\'s groups and their subgroups
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {ProcessOfferStructureOrderRequestDto} processOfferStructureOrderRequestDto New order for the offer\&#39;s groups and subgroups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessOfferStructureOrder(userId: string, processId: string, processOfferId: string, processOfferStructureOrderRequestDto: ProcessOfferStructureOrderRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update process offer subgroup
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {number} processOfferSubgroupId 
     * @param {ProcessOfferSubgroupUpdateRequestDto} processOfferSubgroupUpdateRequestDto Process offer subgroup update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessOfferSubgroup(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, processOfferSubgroupUpdateRequestDto: ProcessOfferSubgroupUpdateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update the realization comment of a process offer subgroup — allowed also on a sent offer
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {number} processOfferSubgroupId 
     * @param {UpdateProcessOfferCommentRequestDto} updateProcessOfferCommentRequestDto Realization comment of a group or subgroup; it prints only on the realization order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessOfferSubgroupComment(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, updateProcessOfferCommentRequestDto: UpdateProcessOfferCommentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update process offer subgroup dish
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {number} processOfferSubgroupId 
     * @param {number} processOfferSubgroupDishId 
     * @param {UpdateProcessOfferSubgroupDishRequestDto} updateProcessOfferSubgroupDishRequestDto Update process offer subgroup dish request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessOfferSubgroupDish(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, processOfferSubgroupDishId: number, updateProcessOfferSubgroupDishRequestDto: UpdateProcessOfferSubgroupDishRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update process offer subgroup
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {number} processOfferSubgroupId 
     * @param {UpdateProcessOfferSubgroupDishesRequestDto} updateProcessOfferSubgroupDishesRequestDto Update process offer subgroup dishes request (add or remove)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessOfferSubgroupDishes(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, updateProcessOfferSubgroupDishesRequestDto: UpdateProcessOfferSubgroupDishesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Set selected dishes in a PACKAGE subgroup pool
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {number} processOfferSubgroupId 
     * @param {ProcessOfferSubgroupSelectionRequestDto} processOfferSubgroupSelectionRequestDto Set which pool dishes are selected in a PACKAGE subgroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessOfferSubgroupSelection(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, processOfferSubgroupSelectionRequestDto: ProcessOfferSubgroupSelectionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestProcessOffersApi - object-oriented interface
 */
export class RestProcessOffersApi extends BaseAPI implements RestProcessOffersApiInterface {
    /**
     * 
     * @summary Deep-copy an existing offer into a target process and multi-offer group
     * @param {string} userId 
     * @param {ProcessOfferCopyRequestDto} processOfferCopyRequestDto Deep copy an offer into another process+multi-offer with new metadata
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public copyProcessOffer(userId: string, processOfferCopyRequestDto: ProcessOfferCopyRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).copyProcessOffer(userId, processOfferCopyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a predefined-offer template attached to the synthetic system process and multi-offer group dedicated to predefined offers. Returns the full offer so the client can route straight to the standard offer view. 
     * @summary Create a predefined-offer template (hosted under the system process)
     * @param {string} userId 
     * @param {PredefinedOfferCreationRequestDto} predefinedOfferCreationRequestDto Predefined-offer (template) creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPredefinedOffer(userId: string, predefinedOfferCreationRequestDto: PredefinedOfferCreationRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).createPredefinedOffer(userId, predefinedOfferCreationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create process offer
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} multiProcessOfferGroupId 
     * @param {ProcessOfferCreationRequestDto} processOfferCreationRequestDto Process offer creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createProcessOffer(userId: string, processId: string, multiProcessOfferGroupId: string, processOfferCreationRequestDto: ProcessOfferCreationRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).createProcessOffer(userId, processId, multiProcessOfferGroupId, processOfferCreationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create process offer group
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {ProcessOfferGroupCreationRequestDto} processOfferGroupCreationRequestDto Process offer group creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createProcessOfferGroup(userId: string, processId: string, processOfferId: string, processOfferGroupCreationRequestDto: ProcessOfferGroupCreationRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).createProcessOfferGroup(userId, processId, processOfferId, processOfferGroupCreationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create process offer subgroup
     * @param {string} userId 
     * @param {string} processId 
     * @param {number} processOfferGroupId 
     * @param {ProcessOfferSubgroupCreationRequestDto} processOfferSubgroupCreationRequestDto Process offer subgroup creation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createProcessOfferSubgroup(userId: string, processId: string, processOfferGroupId: number, processOfferSubgroupCreationRequestDto: ProcessOfferSubgroupCreationRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).createProcessOfferSubgroup(userId, processId, processOfferGroupId, processOfferSubgroupCreationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete process offer group
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteProcessOfferGroup(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).deleteProcessOfferGroup(userId, processId, processOfferId, processOfferGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete process offer subgroup
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {number} processOfferSubgroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteProcessOfferSubgroup(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).deleteProcessOfferSubgroup(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Splits the subgroup\'s budget (guests × per-guest portions or grams) across its dishes in a single transaction, most expensive first and never below a dish\'s order minimum. A plain station keeps the dishes the budget covers and deselects the rest; a pick pool or a subgroup of a set inserted from a definition splits only among the selected dishes and never changes the selection. No-op for subgroups without a per-guest budget.
     * @summary Distribute the guest portion budget across a subgroup\'s dishes
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {number} processOfferSubgroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public distributeProcessOfferSubgroupPortions(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).distributeProcessOfferSubgroupPortions(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get process offer
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessOffer(userId: string, processId: string, processOfferId: string, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).getProcessOffer(userId, processId, processOfferId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get process offer group
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessOfferGroupDetails(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).getProcessOfferGroupDetails(userId, processId, processOfferId, processOfferGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get process offer status allowed transitions
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessOfferStatusAllowedTransitions(processId: string, processOfferId: string, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).getProcessOfferStatusAllowedTransitions(processId, processOfferId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get process offer subgroup
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {number} processOfferSubgroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessOfferSubgroup(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).getProcessOfferSubgroup(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get process offer subgroup dishes
     * @param {string} userId 
     * @param {string} processId 
     * @param {number} processOfferGroupId 
     * @param {number} processOfferSubgroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessOfferSubgroupDishes(userId: string, processId: string, processOfferGroupId: number, processOfferSubgroupId: number, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).getProcessOfferSubgroupDishes(userId, processId, processOfferGroupId, processOfferSubgroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insert (deep-copy) a library group into this offer
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {InsertGroupFromLibraryRequestDto} insertGroupFromLibraryRequestDto The library group to deep-copy into this offer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public insertGroupFromLibrary(userId: string, processId: string, processOfferId: string, insertGroupFromLibraryRequestDto: InsertGroupFromLibraryRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).insertGroupFromLibrary(userId, processId, processOfferId, insertGroupFromLibraryRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insert (deep-copy) a library subgroup into a group of this offer
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {InsertSubgroupFromLibraryRequestDto} insertSubgroupFromLibraryRequestDto The library subgroup to deep-copy into a group of this offer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public insertSubgroupFromLibrary(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, insertSubgroupFromLibraryRequestDto: InsertSubgroupFromLibraryRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).insertSubgroupFromLibrary(userId, processId, processOfferId, processOfferGroupId, insertSubgroupFromLibraryRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search for process offers across all processes (all filters optional)
     * @param {number} page 
     * @param {number} pageSize 
     * @param {ProcessOfferSearchRequestDto} processOfferSearchRequestDto Process offer search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchProcessOffers(page: number, pageSize: number, processOfferSearchRequestDto: ProcessOfferSearchRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).searchProcessOffers(page, pageSize, processOfferSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update process offer
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {ProcessOfferUpdateRequestDto} processOfferUpdateRequestDto Process offer update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessOffer(userId: string, processId: string, processOfferId: string, processOfferUpdateRequestDto: ProcessOfferUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).updateProcessOffer(userId, processId, processOfferId, processOfferUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update process offer group
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {ProcessOfferGroupUpdateRequestDto} processOfferGroupUpdateRequestDto Process offer group update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessOfferGroup(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferGroupUpdateRequestDto: ProcessOfferGroupUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).updateProcessOfferGroup(userId, processId, processOfferId, processOfferGroupId, processOfferGroupUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the realization comment of a process offer group — allowed also on a sent offer
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {UpdateProcessOfferCommentRequestDto} updateProcessOfferCommentRequestDto Realization comment of a group or subgroup; it prints only on the realization order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessOfferGroupComment(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, updateProcessOfferCommentRequestDto: UpdateProcessOfferCommentRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).updateProcessOfferGroupComment(userId, processId, processOfferId, processOfferGroupId, updateProcessOfferCommentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Include or exclude an optional PACKAGE group
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {ProcessOfferGroupSelectionRequestDto} processOfferGroupSelectionRequestDto Include or exclude an optional PACKAGE group
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessOfferGroupSelection(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferGroupSelectionRequestDto: ProcessOfferGroupSelectionRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).updateProcessOfferGroupSelection(userId, processId, processOfferId, processOfferGroupId, processOfferGroupSelectionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update process offer schedule
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {ProcessOfferScheduleUpdateRequestDto} processOfferScheduleUpdateRequestDto Process offer schedule update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessOfferSchedule(userId: string, processId: string, processOfferId: string, processOfferScheduleUpdateRequestDto: ProcessOfferScheduleUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).updateProcessOfferSchedule(userId, processId, processOfferId, processOfferScheduleUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update process offer status
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {ProcessOfferUpdateStatusRequestDto} processOfferUpdateStatusRequestDto Process offer update status request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessOfferStatus(userId: string, processId: string, processOfferId: string, processOfferUpdateStatusRequestDto: ProcessOfferUpdateStatusRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).updateProcessOfferStatus(userId, processId, processOfferId, processOfferUpdateStatusRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reorder the offer\'s groups and their subgroups
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {ProcessOfferStructureOrderRequestDto} processOfferStructureOrderRequestDto New order for the offer\&#39;s groups and subgroups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessOfferStructureOrder(userId: string, processId: string, processOfferId: string, processOfferStructureOrderRequestDto: ProcessOfferStructureOrderRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).updateProcessOfferStructureOrder(userId, processId, processOfferId, processOfferStructureOrderRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update process offer subgroup
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {number} processOfferSubgroupId 
     * @param {ProcessOfferSubgroupUpdateRequestDto} processOfferSubgroupUpdateRequestDto Process offer subgroup update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessOfferSubgroup(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, processOfferSubgroupUpdateRequestDto: ProcessOfferSubgroupUpdateRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).updateProcessOfferSubgroup(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, processOfferSubgroupUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the realization comment of a process offer subgroup — allowed also on a sent offer
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {number} processOfferSubgroupId 
     * @param {UpdateProcessOfferCommentRequestDto} updateProcessOfferCommentRequestDto Realization comment of a group or subgroup; it prints only on the realization order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessOfferSubgroupComment(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, updateProcessOfferCommentRequestDto: UpdateProcessOfferCommentRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).updateProcessOfferSubgroupComment(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, updateProcessOfferCommentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update process offer subgroup dish
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {number} processOfferSubgroupId 
     * @param {number} processOfferSubgroupDishId 
     * @param {UpdateProcessOfferSubgroupDishRequestDto} updateProcessOfferSubgroupDishRequestDto Update process offer subgroup dish request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessOfferSubgroupDish(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, processOfferSubgroupDishId: number, updateProcessOfferSubgroupDishRequestDto: UpdateProcessOfferSubgroupDishRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).updateProcessOfferSubgroupDish(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, processOfferSubgroupDishId, updateProcessOfferSubgroupDishRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update process offer subgroup
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {number} processOfferSubgroupId 
     * @param {UpdateProcessOfferSubgroupDishesRequestDto} updateProcessOfferSubgroupDishesRequestDto Update process offer subgroup dishes request (add or remove)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessOfferSubgroupDishes(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, updateProcessOfferSubgroupDishesRequestDto: UpdateProcessOfferSubgroupDishesRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).updateProcessOfferSubgroupDishes(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, updateProcessOfferSubgroupDishesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set selected dishes in a PACKAGE subgroup pool
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferGroupId 
     * @param {number} processOfferSubgroupId 
     * @param {ProcessOfferSubgroupSelectionRequestDto} processOfferSubgroupSelectionRequestDto Set which pool dishes are selected in a PACKAGE subgroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessOfferSubgroupSelection(userId: string, processId: string, processOfferId: string, processOfferGroupId: number, processOfferSubgroupId: number, processOfferSubgroupSelectionRequestDto: ProcessOfferSubgroupSelectionRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOffersApiFp(this.configuration).updateProcessOfferSubgroupSelection(userId, processId, processOfferId, processOfferGroupId, processOfferSubgroupId, processOfferSubgroupSelectionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

